import { type IBucket, IBucketID } from '@bridebook/models/source/models/Countries/Buckets.types';
import { PremiumTiers } from '@bridebook/toolbox/src/constants';

const result: IBucket = {
  id: IBucketID.EMERGING,
  settings: {
    automaticDowngradeToUnverified: null,
    weddingFairs: {
      venue: {
        [PremiumTiers.Unverified]: 1,
        [PremiumTiers.Tier_0]: 1,
        [PremiumTiers.Tier_0_5]: 1,
        [PremiumTiers.Tier_1]: 1,
        [PremiumTiers.Tier_2]: 1,
        [PremiumTiers.Tier_2_5]: 2,
        [PremiumTiers.Tier_3]: 4,
        [PremiumTiers.Tier_4]: 4,
      },
      types: {
        excluded: ['group'],
      },
    },
    templatedResponses: {
      venue: {
        [PremiumTiers.Unverified]: 1,
        [PremiumTiers.Tier_0]: 1,
        [PremiumTiers.Tier_0_5]: 1,
        [PremiumTiers.Tier_1]: 2,
        [PremiumTiers.Tier_2]: 2,
        [PremiumTiers.Tier_2_5]: 4,
        [PremiumTiers.Tier_3]: 6,
        [PremiumTiers.Tier_4]: Infinity,
      },
      types: {
        excluded: ['group'],
      },
    },
    autoFollowUpTemplatedResponses: {
      venue: {
        [PremiumTiers.Tier_2_5]: 1,
        [PremiumTiers.Tier_3]: 4,
        [PremiumTiers.Tier_4]: Infinity,
      },
      tier: {
        minimum: PremiumTiers.Tier_2_5,
      },
      types: {
        excluded: ['group'],
      },
    },
    instagramIntegration: {
      tier: {
        minimum: PremiumTiers.Tier_3,
      },
      types: {
        included: ['venue'],
      },
    },
    realWeddings: {
      tier: {
        minimum: PremiumTiers.Tier_2_5,
      },
      types: {
        included: ['venue'],
      },
    },
    realWeddingsCarousel: null,
    trendingCarousel: true,
    trendingCarouselSuppliers: {
      tier: {
        minimum: PremiumTiers.Unverified,
      },
      types: {
        included: ['venue'],
      },
    },
    roiSummary: null,
    badges: {
      tier: {
        minimum: PremiumTiers.Unverified,
      },
      types: {
        included: ['venue'],
      },
    },
    topSpot: null,
    multiCounty: null,
    venueTypeHero: null,
    couplesIntel: {
      tier: {
        minimum: PremiumTiers.Tier_2_5,
      },
      types: {
        included: ['venue'],
      },
    },
    lostLeadsStats: {
      tier: {
        minimum: PremiumTiers.Tier_3,
      },
      types: {
        included: ['venue'],
      },
    },
    lostLeadTracking: {
      tier: {
        minimum: PremiumTiers.Tier_3,
      },
      venue: 5,
    },
    yourCompetitors: {
      tier: {
        minimum: PremiumTiers.Tier_3,
      },
      types: {
        included: ['venue'],
      },
    },
    couplesActivity: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
    contactCouples: {
      venue: {
        [PremiumTiers.Tier_3]: 4,
        [PremiumTiers.Tier_4]: 6,
      },
      tier: {
        minimum: PremiumTiers.Tier_3,
      },
      types: {
        excluded: ['group'],
      },
    },
    lostLeadsInsightsEnquirySource: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      types: {
        included: ['venue'],
      },
    },
    revealCoupleEmailAddress: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        excluded: ['group'],
      },
    },
    revealCouplePhoneNumber: {
      tier: {
        minimum: PremiumTiers.Tier_0_5,
      },
      types: {
        excluded: ['group'],
      },
    },
    coupleTargeting: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      types: {
        included: ['venue'],
      },
    },
    coupleTargetingGuestCount: {
      tier: {
        minimum: PremiumTiers.Tier_2_5,
      },
      types: {
        included: ['venue'],
      },
    },
    lateAvailability: {
      tier: {
        minimum: PremiumTiers.Tier_2_5,
      },
      venue: {
        [PremiumTiers.Tier_2_5]: 4,
        [PremiumTiers.Tier_3]: 8,
        [PremiumTiers.Tier_4]: Infinity,
      },
      types: {
        excluded: ['group'],
      },
    },
    deals: {
      tier: {
        minimum: PremiumTiers.Tier_2,
        minimumByType: {
          venue: PremiumTiers.Tier_2_5,
        },
      },
      types: {
        included: ['venue'],
      },
    },
    searchOptimisation: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      types: {
        included: ['venue'],
      },
    },
    bridebookDiscounts: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
    videoTours: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        excluded: ['group'],
      },
    },
    professionalNetwork: null,
    specialOfferRecommendation: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['venue'],
      },
    },
    couplesInsightsSearchAppearances: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
    couplesInsightsProfileViews: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: ['venue'],
      },
    },
    couplesInsightsEnquiries: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
    searchPerformance: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
    socialMediaSupport: null,
    marketInsightsStats: null,
    marketInsightsStatsCoupleBudget: null,
    bridebookInstitute: null,
    upgradePlan: {
      tier: {
        minimum: PremiumTiers.Unverified,
      },
      types: {
        excluded: ['group'],
      },
    },
    weddingReports: null,
    searchBoost: {
      venue: {
        comingSoon: {
          [PremiumTiers.Tier_3]: true,
        },
        billingPeriod: 'monthly',
      },
      types: {
        excluded: ['group'],
      },
    },
    adminBanners: true,
    businessSelfSignUp: true,
    featureTutorials: null,
    aboutYou: null,
    countyDropdown: true,
    searchPresets: null,
    smartEmails: null,
    locations: null,
    onboardingConciergeFlow: true,
    enquiryWidget: {
      types: {
        included: ['venue'],
      },
    },
    trends: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
      types: {
        included: ['venue'],
      },
    },
    historicalSearchPositionChart: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
    keepRelationsOnTierDowngrade: null,
    replyToReviews: {
      tier: {
        minimum: PremiumTiers.Tier_2_5,
      },
      types: {
        included: ['venue'],
      },
    },
    inspirationAndAdvice: null,
    specialOffersCarousel: true,
    rapidResponder: {
      tier: {
        minimum: PremiumTiers.Tier_1,
      },
      types: {
        included: '*',
        excluded: ['group', 'venue'],
      },
    },
    featuredSupplierMarker: {
      tier: {
        minimum: PremiumTiers.Tier_2,
      },
    },
    youMayAlsoLikeCarousel: {
      venue: [PremiumTiers.Unverified],
    },
    couplesAlsoLikeCarousel: {
      venue: [PremiumTiers.Tier_0, PremiumTiers.Tier_1],
    },
    additionalImageOnSearch: {
      tier: {
        minimum: PremiumTiers.Tier_3,
      },
    },
    quickFilters: {
      venue: [
        'hasShowroundViewingDatesAvailable',
        'exclusiveUse',
        'weddingLicence',
        'hasLateAvailability',
      ],
    },
    recommendedSuppliersCarousel: null,
    recommendations: {
      tier: {
        minimum: PremiumTiers.Tier_0,
      },
      types: {
        included: ['venue'],
      },
    },
  },
};

export default {
  [result.id]: result,
};
